<template>
    <div class="row">
        <!-- Stats Cards -->
        <!-- <div class="col-lg-3 col-md-6" v-for="(card, index) in statsCards" :key="index">
        <stats-card
            :title="card.title"
            :sub-title="card.subTitle"
            :type="card.type"
            :icon="card.icon"
        >
            <div slot="footer" v-html="card.footer"></div>
        </stats-card>
        </div>
        <div class="col-lg-12">
        <country-map-card :regions="dashboardData.applicationsByRegions"></country-map-card>
        </div> -->
        <div class="col-5 db-filters-holder" v-if="isInitialized">
           
        </div>
        <div class="col-12" v-if="isInitialized">
            <tabs ref="tab-grants" type="info" @activate-tab="activateTab" square>
                <tab-pane :id="'grants_' + grant.grantId" :label="grant.description" v-for="grant in grants" v-bind:key="grant.grantId">
                    <div class="col-12 mb-3 dashboard-filter" v-if="isInitialized">
                    <el-select class="filter-select mr-2 pull-right" v-model="filters.final_status" placeholder="Filter by awarded status" clearable @change="initDashboard()">
                <el-option v-for="item in filterOptions.final_status" :key="item.value" :label="item.text" :value="item.value" />
            </el-select>
            <el-select class="filter-select mr-2 pull-right" v-model="filters.status" placeholder="Filter by status" clearable @change="initDashboard()">
                <el-option v-for="item in filterOptions.status" :key="item.value" :label="item.text" :value="item.value" />
            </el-select>
        </div>
                    <applications-card
                        :title="$t('dashboard.card_title__applications')"
                        :data="dashboardData.generalApplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :grant-id="grant.grantId"
                    ></applications-card>
                    <applications-by-card
                        v-if="grant.grantId !== 5"
                        :title="$t('dashboard.card_title__applications_by_objectives')"
                        :type="'by-o'"
                        :filters="filters"
                        :data="dashboardData.objectivesApplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'objectives'"
                        :grant-id="grant.grantId"></applications-by-card>
                    <applications-by-card
                        v-if="grant.grantId != 4 && grant.grantId !== 5"
                        :title="$t('dashboard.card_title__applications_by_diagnostic_tools')"
                        :type="'by-dt'"
                        :filters="filters"
                        :data="dashboardData.diagnosticToolsApplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'diagnosticTools'"
                        :grant-id="grant.grantId"></applications-by-card>
                    <applications-by-card
                        v-else-if="grant.grantId !== 5" :title="$t('dashboard.card_title__applications_by_rrg_objectives')"
                        :type="'by-dt'"
                        :filters="filters"
                        :data="dashboardData.diagnosticToolsApplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'diagnosticTools'"
                        :grant-id="grant.grantId"></applications-by-card>
                    <applications-by-card
                        :title="$t('dashboard.card_title__applications_by_type_of_organization')"
                        :type="'by-to'"
                        :filters="filters"
                        :data="dashboardData.typeOfOrganizationApplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'organizations'"
                        :grant-id="grant.grantId"></applications-by-card>
                    <applications-by-card
                        v-if="grant.grantId === 4" :title="$t('dashboard.card_title__applications_by_keywords')"
                        :type="'by-keywords'"
                        :filters="filters"
                        :data="dashboardData.keywordsApplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'keywords'"
                        :grant-id="grant.grantId"></applications-by-card>
                    <applications-by-card
                        v-if="grant.grantId === 5"
                        :title="$t('dashboard.card_title__applications_by_assessment_type')"
                        :type="'by-o'"
                        :filters="filters"
                        :data="dashboardData.typeOfAssessments"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'assessment'"
                        :grant-id="grant.grantId"></applications-by-card>
                    <applications-by-card
                        v-if="grant.grantId === 5"
                        :title="$t('dashboard.card_title__applications_by_type_of_co-applicant_organization')"
                        :type="'by-o'"
                        :filters="filters"
                        :data="dashboardData.typeOfOrganizationCoapplications"
                        :by-country-data="dashboardData.applicationsByCountry"
                        :data-key="'coapplicant'"
                        :grant-id="grant.grantId"></applications-by-card>
                </tab-pane>
            </tabs>
        </div>
    </div>
</template>
<script>
    import ApplicationsCard from './Cards/ApplicationsCard';
    import ApplicationsByCard from './Cards/ApplicationsByCard';
    import CountryMapCard from './CountryMapCard';
    import StatsCard from 'src/components/Cards/StatsCard';
    import {Select, Option} from 'element-ui';

    import {TabPane, Tabs} from 'src/components';
    import {DashboardService, GrantService} from '@/services';

    export default
    {
        components:
        {
            TabPane,
            Tabs,
            ApplicationsCard,
            ApplicationsByCard,
            StatsCard,
            CountryMapCard,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data()
        {
            return {
                isInitialized: false,
                filters: {},
                filterOptions: {},
                dashboardData: {},
                statsCards: [],
                regions: [],
                grants: [],
                currentGrantId: 0,
            };
        },
        methods:
        {
            initStatsCards()
            {
                this.statsCards = [
                    {
                        title: this.dashboardData.totalApplicants.toString(),
                        subTitle: 'Registered Applicants',
                        type: 'info',
                        icon: 'tim-icons icon-single-02',
                        footer: '***'
                    },
                    {
                        title: this.dashboardData.totalOngoing.toString(),
                        subTitle: 'Ongoing Applications',
                        type: 'warning',
                        icon: 'tim-icons icon-notes',
                        footer: '***'
                    },
                    {
                        title: this.dashboardData.totalSubmitted.toString(),
                        subTitle: 'Submitted Applications',
                        type: 'primary',
                        icon: 'tim-icons icon-send',
                        footer: '***'
                    },
                    {
                        title: this.dashboardData.totalAwarded.toString(),
                        subTitle: 'Awarded Applications',
                        type: 'success',
                        icon: 'tim-icons icon-shape-star',
                        footer: '***'
                    }
                ]
            },
            initCountryMap()
            {
            },
            async initDashboard()
            {
                const vm = this;
                const loader = vm.$loading.show();

                await GrantService.all().then((response) =>
                {
                    vm.grants = response.data;

                    if (vm.currentGrantId === 0)
                    {
                        vm.currentGrantId = vm.grants[0].grantId;
                    }
                });

                await DashboardService.getFilters().then((response) =>
                {
                    vm.filterOptions = response.data;
                });

                await DashboardService.getDashboardData({
                    grant_id: vm.currentGrantId,
                    status: vm.filters.status,
                    final_status: vm.filters.final_status
                }).then((response) =>
                {
                    vm.dashboardData = response.data;
                    //vm.initStatsCards()
                    //vm.initCountryMap();

                    vm.isInitialized = true;
                });

                loader.hide();
            },
            activateTab(ev)
            {
                const vm = this;

                vm.currentGrantId = +ev.id.replace('grants_', '');

                vm.initDashboard();
            },
        },
        mounted()
        {

        },
        beforeMount()
        {
            this.initDashboard();
        },
        beforeDestroy() {}
    };
</script>
<style lang="scss">
    .db-filters-holder
    {
        position: absolute;
        right: 0;
        z-index: 10;
    }
    .dashboard-filter
    {
       margin-left: -15px;
       display:flex;
       justify-content: flex-start;
    align-items: center;
    }
</style>
